<template>
  <div class="flex z-50" :class="$style.undoRedo">
    <button class="p-2" :class="{ 'opacity-40': !canUndo }" type="button" :disabled="!canUndo" @click="undo">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FEFEFE" viewBox="0 -960 960 960">
        <path
            d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z"/>
      </svg>
    </button>
    <button class="p-2" :class="{ 'opacity-40': !canRedo }" type="button" :disabled="!canRedo" @click="redo">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#FEFEFE" viewBox="0 -960 960 960">
        <path
            d="M396-200q-97 0-166.5-63T160-420q0-94 69.5-157T396-640h252L544-744l56-56 200 200-200 200-56-56 104-104H396q-63 0-109.5 40T240-420q0 60 46.5 100T396-280h284v80H396Z"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UndoRedo',
  computed: {
    ...mapGetters('campaign/widget/undoRedo', ['canUndo', 'canRedo']),
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    ...mapActions('campaign/widget/undoRedo', ['undo', 'redo']),
    handleKeyDown(event) {
      const ctrlOrCmd = event.ctrlKey || event.metaKey
      const key = event.key.toLowerCase()

      if (ctrlOrCmd && key === 'z' && !event.shiftKey) {
        event.preventDefault()
        this.undo()
      } else if (
          ctrlOrCmd &&
          ((key === 'y') || (event.shiftKey && key === 'z'))
      ) {
        event.preventDefault()
        this.redo()
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.undoRedo {
  background-color: darken($color-bg-editor, 5);
}
</style>